// Vue3-Migration Phase 2a: Ersatz für vue-moment / `this.$moment(...)`.
// Vue 3 kennt keine globalen Template-Filter mehr; die Datumsformatierung läuft
// jetzt direkt über das bereits vorhandene luxon. Die Ausgabeformate bleiben
// exakt wie zuvor (deutsches Format `DD.MM.YYYY`), damit sich visuell nichts ändert.
import { DateTime } from 'luxon'

// Wert (ISO-String oder Date) -> formatierter String. Standardformat entspricht
// dem früheren moment `DD.MM.YYYY` (luxon-Tokens: `dd.MM.yyyy`).
export function formatDate (value, format = 'dd.MM.yyyy') {
  if (value === null || value === undefined || value === '') return ''
  const dt = value instanceof Date
    ? DateTime.fromJSDate(value)
    : DateTime.fromISO(String(value))
  return dt.isValid ? dt.toFormat(format) : ''
}
